import React, { useState } from 'react';
import s from './s.module.less';
import OnboardingStepContainer from '../OnboardingStepContainer';
import RadioOption from '../RadioOption';
import ActionButtons from '../ActionButtons';

interface EhrAccessStepProps {
    onEhrAccessChange?: (ehrAccess: string) => void;
    onBack?: () => void;
    onNext?: () => void;
    onExit?: () => void;
    currentStep?: number;
    totalSteps?: number;
    initialEhrAccess?: string;
}

const ehrAccessOptions = [
    { id: 'yes-current', label: 'Yes, I have an EHR' },
    { id: 'no-not-planned', label: "No, I don't have an EHR" },
];

export default function EhrAccessStep({
    onEhrAccessChange,
    onBack,
    onNext,
    onExit,
    currentStep = 7,
    totalSteps = 7,
    initialEhrAccess = '',
}: EhrAccessStepProps) {
    const [selectedAccess, setSelectedAccess] = useState<string>(initialEhrAccess);

    const handleAccessChange = (accessId: string) => {
        setSelectedAccess(accessId);

        if (onEhrAccessChange) {
            onEhrAccessChange(accessId);
        }
    };

    return (
        <>
            <OnboardingStepContainer
                currentStep={currentStep}
                totalSteps={totalSteps}
                title="Do you have access to any EHR?"
                subtitle={<>This helps us understand your practice setup. Klarity offers a <span className={s.highlight}>free</span> EHR if you need one.</>}
                showBackButton
                onBack={onBack}
            >
                <div className={s.optionsContainer}>
                    {ehrAccessOptions.map((option) => (
                        <RadioOption
                            key={option.id}
                            id={option.id}
                            label={option.label}
                            checked={selectedAccess === option.id}
                            onChange={handleAccessChange}
                        />
                    ))}
                </div>
            </OnboardingStepContainer>

            <ActionButtons
                showBack
                showNext={false}
                currentStep={currentStep}
                onBack={onBack}
            />
        </>
    );
}
